import React from "react";
import avatarIcon from "../../assets/images/Bot-Avatar2.png";

// Config starter code

function IconBotAvatar () {
    return (
    <div className="Bot-Avatar">
        <img src={avatarIcon} alt="avatar" />
       </div>    )
}
export default IconBotAvatar;